module.exports = __webpack_public_path__ + "front/img/d3.ae65ea9f.png";